import React from 'react';

const Users:React.FC =()=> <div />;

export default Users;
